import { render, staticRenderFns } from "./ProductInventoryQuantity.vue?vue&type=template&id=6c72ffdc&"
import script from "./ProductInventoryQuantity.vue?vue&type=script&lang=ts&"
export * from "./ProductInventoryQuantity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports